module.exports = __webpack_public_path__ + "static/fonts/MaterialIcons-Regular.e79bfd8.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/iconfont/MaterialIcons-Regular.eot
// module id = LhTO
// module chunks = 0